import { createSlice } from "@reduxjs/toolkit";
import {
  buscarTipoLancamentoControleAporte,
} from "../../../services/tipoLancamentoControleAporteService";
import { TipoLancamentoControleAporteModel } from "../../../models/tipoLancamentoControleAporte/tipoLancamentoControleAporteModel";
import { resetAll } from "../../actions/actions";

export interface TipoLancamentoControleAporteState {
  //buscar tipo lançamento de controle aporte
  loading: boolean;
  busca: string | null;
  list: TipoLancamentoControleAporteModel[];
  entity: TipoLancamentoControleAporteModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: TipoLancamentoControleAporteState = {
  //buscar tipo lançamento de controle aporte
  loading: false,
  busca: null,
  list: [],
  entity: {} as TipoLancamentoControleAporteModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const tipoLancamentoControleAporteSlice = createSlice({
  name: "tipoLancamentoControleAporte",
  initialState,
  reducers: {
    //buscar tipo lançamento de controle aporte
    setBuscaTipoLancamentoControleAporte: (state, action) => {
      state.busca = action.payload;
    },
    setEntityTipoLancamentoControleAporte: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarTipoLancamentoControleAporte: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarTipoLancamentoControleAporte: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar tipo lançamento de controle aporte
    builder.addCase(buscarTipoLancamentoControleAporte.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTipoLancamentoControleAporte.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTipoLancamentoControleAporte.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar tipo lançamento de controle aporte
  setBuscaTipoLancamentoControleAporte,
  setEntityTipoLancamentoControleAporte,
  //internal
  setModalCadastrarTipoLancamentoControleAporte,
  setModalDeletarTipoLancamentoControleAporte,
} = tipoLancamentoControleAporteSlice.actions;

export default tipoLancamentoControleAporteSlice.reducer;
